"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nonTestStepTypes = void 0;
const types_js_1 = require("./Definitions/types.js");
exports.nonTestStepTypes = Object.keys(types_js_1.StepDefinitions).filter((stepType) => !stepType.startsWith('Mock') && !stepType.startsWith('Test'));
//# sourceMappingURL=non-test-step-types.js.map